import { useEffect, useState } from 'react';
import { useWorkspaceStore } from './store/workspaceStore';
import { Dashboard } from './features/editor/Dashboard';
import { checkBrowserCompatibility } from './lib/browserSupport';

const DARK_MODE_KEY = 'reels-generator:dark-mode';

export function App() {
  const initialize = useWorkspaceStore((s) => s.initialize);
  const loaded = useWorkspaceStore((s) => s.loaded);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem(DARK_MODE_KEY) !== 'false');
  const [compatWarning, setCompatWarning] = useState<string[] | null>(null);

  useEffect(() => {
    void initialize();
    const report = checkBrowserCompatibility();
    if (!report.supported) setCompatWarning(report.missingFeatures);
  }, [initialize]);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    localStorage.setItem(DARK_MODE_KEY, String(darkMode));
  }, [darkMode]);

  if (!loaded) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-100 text-slate-500 dark:bg-slate-950 dark:text-slate-400">
        Loading your projects…
      </div>
    );
  }

  return (
    <>
      {compatWarning && (
        <div className="border-b border-red-200 bg-red-50 px-4 py-2 text-xs text-red-700 dark:border-red-900 dark:bg-red-900/20 dark:text-red-300">
          Your browser is missing features this app needs ({compatWarning.join(', ')}). For the best experience, use a recent
          desktop version of <strong>Chrome</strong> or <strong>Edge</strong>.
          <button className="ml-2 underline" onClick={() => setCompatWarning(null)}>
            Dismiss
          </button>
        </div>
      )}
      <Dashboard darkMode={darkMode} onToggleDarkMode={() => setDarkMode((d) => !d)} />
    </>
  );
}
